import type { JSX } from 'react';

/**
 * The Trucklane mark: a blue-to-glow gradient tile with the lane chevron, and a
 * soft ring breathing behind it. 30px in the header, 56 on sign-in, 64 in an
 * empty chat, 150 on the overview.
 */
export function Orb({ size }: { size: number }): JSX.Element {
  const radius = size * 0.28;
  const tile = {
    position: 'absolute',
    inset: 0,
    borderRadius: radius,
    background: 'linear-gradient(135deg, var(--primary), var(--acc))',
  } as const;
  const blink = (delay: number): { animation: string } => ({
    animation: `blink 2.4s cubic-bezier(.45,0,.55,1) ${delay}s infinite`,
  });

  return (
    <span
      aria-hidden
      className="relative inline-grid flex-none place-items-center"
      style={{ width: size, height: size }}
    >
      <span style={{ ...tile, opacity: 0.5, animation: 'orb-pulse 3s ease-out infinite' }} />
      <span style={{ ...tile, boxShadow: `0 ${size * 0.08}px ${size * 0.3}px var(--glow)` }} />
      <svg
        viewBox="0 0 24 24"
        width={size * 0.58}
        height={size * 0.58}
        fill="none"
        stroke="white"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
        className="relative"
      >
        <path d="M12 4 5 20" />
        <path d="M12 4l7 16" />
        <path d="M12 11v1" style={blink(0)} />
        <path d="M12 16.5V18" style={blink(0.5)} />
      </svg>
    </span>
  );
}
